export default "__VITE_ASSET__22ztPQAX__"